import { Trans } from "react-i18next";
import React from "react";
import TableHolder from "./TableHolder";

const SingleLineTable = ({ item, selectedOrganisation }) => {

    return (
        <>
            <h2 className="mb-3">
                <span><Trans>Accrued Holidays of {item.employee__full_name}</Trans> </span> - <span>{selectedOrganisation.name}</span>
            </h2>

            <hr />
            <div className="my-3">
                <TableHolder
                    line={item}
                />
            </div>
            <hr />
        </>
    );
};

export default SingleLineTable;
